import React, { useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { config } from '@/config';
import { ValidateURLParams } from '@/components/validate/ValidateURLParams';
import { ViewPage } from '@/components/dashboard/view/view-page';
import DataContext from '@/contexts/DataContext';
import { useLocation } from 'react-router-dom';

const metadata = { title: `${config.site.name}` };

export function Page() {
  const location = useLocation();
  const {currentView} = useContext(DataContext);
  return (
    <React.Fragment>
      <Helmet>
        <title>{metadata.title}</title>
      </Helmet>
      <ValidateURLParams>
        <ViewPage key={currentView?.id}/>
      </ValidateURLParams>
    </React.Fragment>
  );
}
